/**
 * MYAC-919 follow-up — which message the reader is actually looking at.
 *
 * Kept out of the component because it is the one part of the header indicator
 * that can be tested: jsdom has no layout, so the DOM measuring stays in
 * `ChatInterface` and the decision it feeds lives here.
 */

/**
 * Index of the last message whose top has passed the top edge of the scroller —
 * i.e. the one being read, not the one peeking in from below. Returns 0 when
 * nothing has passed it yet (scrolled to the very top).
 */
export function pickVisibleIndex(topsRelativeToScroller: number[], edge = 80): number {
  let index = 0
  for (let i = 0; i < topsRelativeToScroller.length; i++) {
    if (topsRelativeToScroller[i] <= edge) index = i
  }
  return index
}

/**
 * The subject in force at `index`: the last one attached at or before it.
 *
 * Not simply `messages[index].focus`, because a conversation continues without
 * re-attaching — "and the evidence?" carries no marker of its own but is still
 * about the clause two turns above. Blanking the header on those turns read as
 * the assistant losing the thread; the subject stands until a different one is
 * attached (Aymeric, 2026-08-19).
 */
export function subjectInForceAt<T extends { focus?: unknown }>(
  messages: T[],
  index: number,
): NonNullable<T['focus']> | null {
  for (let i = Math.min(index, messages.length - 1); i >= 0; i--) {
    const focus = messages[i]?.focus
    if (focus) return focus as NonNullable<T['focus']>
  }
  return null
}
